import React from 'react';
import WName, {WArticle} from '../WName';
import Eon from '../Eon';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual} from '../common';

// Reactivity is not capable of love, only hierarchy and hate.
export const hate = {
  name: "hate",
  alternatives: "hatred",
  header: <span>
    Reactivity can only <i>hate</i>.
  </span>,
  outside: <span>
    <LRL>Reactivity</LRL> (as ‘<PL>Mamma</PL>’) is incapable of ‘<PL>love</PL>’; the <AL name="fields.">logic</AL> of <PL>containment</PL> is only <AL name="limits">able</AL> to express <i>complience</i>, or <i>hatred</i>.
  </span>,
  preview: <div className="problem-preview">
    [under construction]
  </div>,
//  readMore: <span>
  //</span>,
//  text: <div className="problem-text">

//  </div>,
};
